export default "__VITE_ASSET__Cwc28kqq__"